import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import MobileStep1Form from './Form/MobileStep1Form';
import MobileStep2Form from './Form/MobileStep2Form';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import MobileDetailsHeader from './MobileDetailsHeader';

const DetailsFormContainer = styled.div`
    flex: 1;
    padding: 1em;
    display: flex;
    flex-direction: column;
    max-height: 335px;
`;

const DetailsFormMobile = props => (
    <DetailsFormContainer autocomplete="on">
        <MobileDetailsHeader
            partnerLogo={props.partnerLogo}
            progressPercentage={props.progressPercentage}
            onPartnerClick={props.onPartnerClick}
        />
        <TransitionGroup component={TransitionGroupContainer}>
            {props.mobileWizardStep === 1 ? (
                <CssTransition key={1} timeoutInMs={650}>
                    <MobileStep1Form
                        onSubmit={() => props.mobileGoWizardStep(2)}
                        onBackToAmount={props.onBackToAmount}
                        partnerLogo={props.partnerLogo}
                        partnerName={props.partnerName}
                    />
                </CssTransition>
            ) : (
                <CssTransition key={2} timeoutInMs={650}>
                    <MobileStep2Form
                        amountFormated={props.amountFormated}
                        onSubmit={props.onSubmit}
                        onBackToAmount={props.onBackToAmount}
                        mobileGoWizardStep={props.mobileGoWizardStep}
                        partnerLogo={props.partnerLogo}
                        paymentMethod={props.paymentMethod}
                    />
                </CssTransition>
            )}
        </TransitionGroup>
    </DetailsFormContainer>
);

DetailsFormMobile.propTypes = {
    onBackToAmount: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    amountFormated: PropTypes.string.isRequired,
    mobileGoWizardStep: PropTypes.func.isRequired,
    mobileWizardStep: PropTypes.number.isRequired,
    progressPercentage: PropTypes.number.isRequired,
    partnerLogo: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    onPartnerClick: PropTypes.func
};

export default DetailsFormMobile;



// WEBPACK FOOTER //
// ./src/components/Donation/DetailsFormMobile.jsx